import { B300, B500 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from '../center-justified-container';
import { MobileVerticallyPaddedContainer } from './mobile-vertically-padded-container';

export type EnterpriseAnnualBillingMessageProps = {
  onToggleToAnnualBilling: () => void;
};

const EnterpriseAnnualBillingMessage = ({
  onToggleToAnnualBilling
}: EnterpriseAnnualBillingMessageProps) => (
  <CenterJustifiedContainer>
    <MobileVerticallyPaddedContainer>
      <FormattedMessage
        tagName={'span'}
        id="enterpriseMonthlyBilling"
        defaultMessage="<a>Billed annually</a>. Switch the Billing cycle to Annual to view Enterprise pricing."
        values={{
          a: (chunks: ReactNode) => (
            <StyledBilledAnnual
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onToggleToAnnualBilling();
              }}
            >
              {chunks}
            </StyledBilledAnnual>
          )
        }}
      ></FormattedMessage>
    </MobileVerticallyPaddedContainer>
  </CenterJustifiedContainer>
);

const StyledBilledAnnual = styled.a`
  color: ${B300};
  &:hover {
    color: ${B500};
  }
`;

export { EnterpriseAnnualBillingMessage };
